import React from "react";

type BadgeStripProps = {
  items?: string[];
};

export function BadgeStrip({ items = [] }: BadgeStripProps) {
  if (!items.length) return null;

  const trackItems = [...items, ...items];

  return (
    <div className="relative overflow-hidden bg-slate-100">
      <div className="badge-ticker-track py-2">
        {trackItems.map((text, i) => (
          <span
            key={`${text}-${i}`}
            className="inline-flex shrink-0 items-center gap-1 mx-1 rounded-full border border-emerald-100 bg-emerald-50 px-3 py-1 text-xs font-medium text-emerald-800"
          >
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
            {text}
          </span>
        ))}
      </div>
    </div>
  );
}
